import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { ColumnsTable } from 'safe'
import { formatPipe, transformDate } from '../../utils/utils'
import { onCheckCb } from '../../utils/onCheckIfExistCb'
import { docs } from '../../userConfig'
import Select from '../../components/Inputs/Select'
import CurrencyInput from '../../components/Inputs/CurrencyInput'

const WatchDetails: React.FC<WatchDetailsProps> = ({ defaultValues }) => {
  const form = useForm<any>({
    defaultValues: {
      document: defaultValues?.sale?.document || '',
      name: defaultValues?.sale?.clientName || '',
      amount: defaultValues?.sale?.cost || '',
    },
  })

  const onSubmit = (data: any) => {
    console.log(data)
  }

  const columns: ColumnsTable[] = [
    {
      title: 'Artículo',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record?.type === 'PRODUCT' ? 'Producto' : 'Servicio'}
        </ColumnItemWrapper>
      ),
    },
  ]

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'P',
      text: 'P',
    },
    {
      value: 'G',
      text: 'G',
    },
    {
      value: 'C',
      text: 'C',
    },
  ]

  const onGetDocumentType = () => {
    return docs?.find((doc) => doc.value === defaultValues?.sale?.documentType)
  }

  return (
    <Form classes="grid grid-cols-12 gap-3" form={form} onSubmit={onSubmit}>
      {/* <FormItem
        name="documentType"
        rules={{ required: 'Es necesario un nombre' }}
        classes="col-span-12 sm:col-span-12 md:col-span-2"
        defaultValue={onGetDocumentType()}
      >
        <Select options={docs} label="Tipo" disabled />{' '}
      </FormItem>

      <FormItem
        name="document"
        rules={{ required: 'Es necesario un nombre' }}
        classes="col-span-12 sm:col-span-12 md:col-span-3"
        defaultValue={onGetDocumentType()}
      >
        <InputText label="Documento" disableInput />{' '}
      </FormItem>

      <FormItem
        name="name"
        rules={{ required: 'Es necesario un nombre' }}
        classes="col-span-12 sm:col-span-12 md:col-span-7"
        defaultValue={onGetDocumentType()}
      >
        <InputText label="Nombre del cliente" disableInput />{' '}
      </FormItem>

      <FormItem
          name="amount"
          classes={`col-span-12 sm:col-span-12 md:col-span-5`}
          defaultValue={''}
          rules={{
            required: 'Es necesario el monto',
            // pattern: { value: /^\d+(\.\d{2})?$/, message: 'Monto inválido' },
          }}        >
          <CurrencyInput disabled addDecimals={true} mask={'Bs. num'} label='Total de la venta' />
        </FormItem> */}

      <div className="col-span-12">
        <label className="text-primary font-bold text-[17px]">
          Detalle comanda #{defaultValues?.foodOrderCode}
        </label>
      </div>

      <div className="bg-[#F5F5F5] col-span-12 p-[20px]">
        <div className="flex flex-col">
          <div className="flex flex-row justify-between">
            <div className="flex flex-col">
              <label className="text-[14px] font-bold">
                Nombre del cliente
              </label>
              <label className="text-[14px] ">
                {defaultValues?.sale?.clientName}
              </label>
            </div>

            <div className="flex flex-col w-[150px]">
              <label className="text-[14px] font-bold">Documento</label>
              <label className="text-[14px]">{`${defaultValues?.sale?.documentType}-${defaultValues?.sale?.document}`}</label>
            </div>
          </div>

          <div className="flex flex-row justify-between mt-[5px]">
            <div className="flex flex-col">
              <label className="text-[14px] font-bold">Nro de factura</label>
              <label className="text-[14px] ">
                {defaultValues?.sale?.invoiceCode || 'N/A'}
              </label>
            </div>

            <div className="flex flex-col w-[150px]">
              <label className="text-[14px] font-bold">Fecha</label>
              <label className="text-[14px] ">
                {transformDate(new Date(defaultValues?.date).toISOString())}
              </label>
            </div>
          </div>

          <div className="flex flex-row justify-between mt-[5px]">
            <div className="flex flex-col">
              <label className="text-[14px] font-bold">Total de la venta</label>
              <label className="text-[14px]">
                Bs {formatPipe(defaultValues?.sale?.cost)}
              </label>
            </div>

            <div className="flex flex-col w-[150px]">
              <label className="text-[14px] font-bold">
                Total de la venta (Ref)
              </label>
              <label className="text-[14px]">
                $ {formatPipe(defaultValues?.sale?.usdCost)}
              </label>
            </div>
          </div>

          <div className="flex flex-row justify-between mt-[5px]">
            <div className="flex flex-col">
              <label className="text-[14px] font-bold">Mesonero</label>
              <label className="text-[14px]">
                {defaultValues?.user?.name || 'N/A'}
              </label>
            </div>

            <div className="flex flex-col w-[150px]">
              <label className="text-[14px] font-bold">Nombre de la mesa</label>
              <label className="text-[14px]">{`${defaultValues?.foodTable?.name}`}</label>
            </div>
          </div>
        </div>
      </div>

      <div className="col-span-12 max-h-[300px] overflow-y-auto mt-[20px]">
        <Table
          data={defaultValues?.items || []}
          columns={columns}
          showPagination={false}
        />
      </div>
    </Form>
  )
}

export default WatchDetails

interface WatchDetailsProps {
  defaultValues: any
}
